import React from "react";
import classes from "./Footer.module.css";

const footer = () => {
    return (
        <div className={classes.Footer}>
            <div>&copy; HD Film Plus+ | All rights reserved.</div>
            <nav>
                <a href="https://www.instagram.com/gmsonr" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-instagram"></i>
                </a>
                <a href="https://www.twitter.com/gmsonrr" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-twitter"></i>
                </a>
            </nav>
        </div>
    );
};

export default footer;
